export default __webpack_public_path__ + "static/media/flag-philippines.b645be95.svg";